var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.status ? _c('dialog-scroll-lock', {
    attrs: {
      "width": "500",
      "value": true
    },
    on: {
      "input": function ($event) {
        return _vm.$emit('close');
      }
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "px-4"
  }, [_vm.status.isDirty ? _c('div', [_vm._v("Your changes have been saved")]) : _c('div', [_vm._v("Project status")]), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('close');
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiClose)
    }
  })], 1)], 1), _c('v-card-subtitle', {
    staticClass: "px-4"
  }, [_vm._t("default", function () {
    return [_vm._v(" Revisit this page at any time to make more changes ")];
  })], 2), _c('group-video-status', {
    staticClass: "pb-6",
    attrs: {
      "status": _vm.status
    }
  }), _c('v-divider'), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    on: {
      "click": function ($event) {
        return _vm.$emit('continue');
      }
    }
  }, [_vm._v("Continue editing")]), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('close');
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }